import posthog from 'posthog-js';

type PostHogUserProperties = {
  email: string;
  name?: string;
  organization_id: string;
};

export const identifyUser = ({
  userId,
  properties,
}: {
  userId: string;
  properties: PostHogUserProperties;
}): void => {
  posthog.identify(userId, properties);
};
